import React from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";

const TableProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  columns,
  tableColumns,
  buttonLoader,
  setTableColumns,
  updateTableProperties,
}) => {
  const handleCheckboxChange = (checked, column) => {
    setTableColumns((previous) => {
      const updated = { ...previous };
      if (checked) {
        updated[column.columnName] = true;
      } else {
        delete updated[column.columnName];
      }
      return updated;
    });
  };

  const allSelected =
    columns.length > 0 &&
    columns.every((column) => !tableColumns[column.columnName]);

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        <Table ref={tableRef} className="m-0 custom-table" hover striped>
          <thead className="position-sticky top-0 z-1">
            <tr>
              <th style={{ width: 45 }} className="text-center">
                <Form.Check
                  type="checkbox"
                  checked={allSelected}
                  onChange={() => {
                    setTableColumns(
                      allSelected
                        ? {}
                        : columns.reduce((selected, column) => {
                            selected[column.columnName] = true;
                            return selected;
                          }, {})
                    );
                  }}
                />
              </th>
              <th>Column Label</th>
              <th>Column Name</th>
            </tr>
          </thead>
          <tbody>
            {columns.map((column) => {
              const checked = !tableColumns[column.columnName];
              return (
                <tr key={column.columnName}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={checked}
                      onChange={() => handleCheckboxChange(checked, column)}
                    />
                  </td>
                  <td>{column.columnLabel}</td>
                  <td>{column.columnName}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </Offcanvas.Body>
      <div className="p-2 border-top shadow-sm text-end">
        <button
          disabled={buttonLoader}
          onClick={updateTableProperties}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Applying...
            </div>
          ) : (
            "Apply"
          )}
        </button>
      </div>
    </Offcanvas>
  );
};

export default TableProperties;
